export const checkListPassword = [
    'A senha deverá conter no mínimo 6 e no máximo 15 caracteres;',
    'Ao menos 1 letra deve ser maiúscula;',
    'Ao menos 1 letra deve ser minúscula;',
    'E deve conter ao menos 1 número',
    // eslint-disable-next-line no-useless-escape
    '1 caractere especial (@!#$%^&*()_+={}[\]:;<>,.?~).',
]